import { CSSTasks } from './tasks/css-tasks'
import { HTMLtasks } from './tasks/html-tasks'
import { JavaScriptTasks } from './tasks/javascript-tasks'
import { ReactTasks } from './tasks/react-tasks'
import { SQLTasks } from './tasks/sql-tasks'
import { TypeScriptTasks } from './tasks/typescript-tasks'

export type Category = {
  id: string
  title: string
  tasks: Task[]
}

export type Task = {
  id: string
  categoryId: string
  title: string
  code: string
  lang: string
}

export const categories: Category[] = [
  {
    id: '1',
    title: 'HTML',
    tasks: HTMLtasks,
  },
  {
    id: '2',
    title: 'CSS',
    tasks: CSSTasks,
  },
  {
    id: '3',
    title: 'JavaScript',
    tasks: JavaScriptTasks,
  },
  {
    id: '4',
    title: 'React',
    tasks: ReactTasks,
  },
  {
    id: '5',
    title: 'TypeScript',
    tasks: TypeScriptTasks,
  },
  {
    id: '6',
    title: 'SQL',
    tasks: SQLTasks,
  },
]
